<template>
  <Alinea v-if="computedText" :blocks="computedText.blocks" variant="body" :heading-level="2" />
</template>

<script setup lang="ts">
import type { ICmsContentTexts } from '~~/types/_cms-types';

interface IProps extends ICmsContentTexts {
  staticData?: ICmsContentTexts;
}

const props = defineProps<IProps>();

/*
  Performance HTTP1.1: when this component is directly used in a page it's NOT dynamically populated with data
  in that case the data is part of staticData.
 */
const computedText = computed(() => {
  return props.staticData?.item?.text || props.text;
});
</script>
